import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { GenericDialogDto } from 'src/app/data/models/dto/generic-dialog.dto';
import { Occasion } from 'src/app/data/models/interfaces/occasion.abstract';
import { BottomSheetOccasionComponent } from 'src/app/ui/components/bottom-sheet-occasion/bottom-sheet-occasion.component';
import { genericDialog } from 'src/app/data/utils/generic-dialog.utils';
import { MatDialog } from '@angular/material/dialog';
import { CustomSnackbarService } from '../custom-snackbar/custom-snackbar-service';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { NewsService } from 'src/app/data/services/news.service';
import { EventsService } from 'src/app/data/services/events.service';
import { News } from 'src/app/data/models/interfaces/news';
import { FormDialogDto } from 'src/app/data/models/dto/form-dialog.dto';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';

@Component({
  selector: 'app-card-occasion',
  templateUrl: './card-occasion.component.html',
  styleUrls: ['./card-occasion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CardOccasionComponent implements OnInit {
  @Output() bottomsheet = new EventEmitter<string>();
  @Output() discardedOccasion = new EventEmitter<boolean>();
  @Input() occasionData: Occasion | undefined;
  @Input() typeOccasion: string = '';
  @Input() editRoute: string | any[] | null | undefined;
  @Input() detailsRoute: string | any[] | null | undefined;
  openUserViewed: boolean = false;
  loading: boolean = false;
  idOccasion: string = '';
  currentTime = Date.now();
  msgPrimaryDiscardDialog: string = '';
  msgDiscardSnackSuccess: string = '';
  imgDiscardDialog: string = '';
  msgDiscardSnackError: string = '';
  msgSecondaryDiscardDialog: string = '';

  constructor(
    private readonly bottomSheet: MatBottomSheet,
    private readonly router: Router,
    private readonly newsService: NewsService,
    private readonly eventsService: EventsService,
    private dialog: MatDialog,
    private snackbarService: CustomSnackbarService
  ) {}

  ngOnInit() {}

  showScheduled(releaseDate?: Date) {
    if (!releaseDate) return false;

    let rDate = new Date(releaseDate);
    return !!rDate && (rDate ? rDate.getTime() > this.currentTime : false);
  }

  updatePage(emit: string, occasion: Occasion) {
    if (emit == 'actionEdit') {
      if (this.typeOccasion === 'NEWS') {
        this.router.navigate(['news', occasion.id]);
      } else {
        this.router.navigate(['event', occasion.id]);
      }
    }
  }

  showUsersViewed() {
    this.openUserViewed = !this.openUserViewed;
  }

  openBottomSheet(occasion: Occasion): void {
    this.bottomSheet.open(BottomSheetOccasionComponent, {
      data: occasion,
      panelClass: ['custom-bottom-sheet-container'],
    });
  }

  discardOccasionMessage(): void {
    if (this.typeOccasion === 'NEWS') {
      this.imgDiscardDialog =
        '../../../../assets/images/news-delete-dialog.svg';
      this.msgDiscardSnackSuccess = 'Notícia excluída com sucesso';
      this.msgPrimaryDiscardDialog =
        'Você tem certeza que deseja excluir esta notícia?';
      this.msgSecondaryDiscardDialog =
        'Você perderá todas as informações inseridas. Além disso, os responsáveis não conseguirão visualizá-la no aplicativo.';
      this.msgDiscardSnackError = 'Erro ao excluir notícia';
    } else {
      this.imgDiscardDialog = ''; //importar imagem para evento aqui
      this.msgDiscardSnackSuccess = 'Evento excluído com sucesso';
      this.msgPrimaryDiscardDialog =
        'Você tem certeza que deseja excluir este evento?';
      this.msgSecondaryDiscardDialog =
        'Você perderá todas as informações inseridas. Além disso, os responsáveis não conseguirão visualizá-lo no aplicativo.';
      this.msgDiscardSnackError = 'Erro ao excluir evento';
    }
  }

  private handleSuccessDelete(): void {
    this.discardedOccasion.emit(true);
    this.snackbarService.open(
      this.msgDiscardSnackSuccess,
      SnackbarTypeEnum.SUCCESS,
      'center',
      'bottom'
    );
  }

  async deleteOccasion(occasion: Occasion) {
    this.discardOccasionMessage();
    const dialogInfo: GenericDialogDto = {
      imageUrl: this.imgDiscardDialog,
      primaryText: this.msgPrimaryDiscardDialog,
      secondaryText: this.msgSecondaryDiscardDialog,
      btnCancelText: 'Não, cancelar',
      btnConfirmText: 'Sim, excluir',
    };
    const confirmation = await genericDialog(
      this.dialog,
      dialogInfo,
      'custom-dialog-confirmation'
    ).toPromise();
    if (confirmation)
      try {
        if (this.typeOccasion === 'NEWS') {
          this.newsService
            .delete(occasion.id!)
            .toPromise()
            .then(() => this.handleSuccessDelete());
        } else {
          this.eventsService
            .remove(occasion.id!)
            .toPromise()
            .then(() => this.handleSuccessDelete());
        }
      } catch (error) {
        console.log(error);
        this.snackbarService.open(
          this.msgDiscardSnackError,
          SnackbarTypeEnum.ERROR,
          'center',
          'bottom'
        );
      }
  }

  async getNews(id: string): Promise<News> {
    return await this.newsService.getById(id).toPromise();
  }

  private async duplicateNews(id: string, newTitle: string): Promise<News> {
    const news = await this.getNews(id);
    const duplicatedNews: News = {
      id: undefined,
      title: newTitle,
      description: news.description,
      year: news.year,
      location: '',
      confirmationDate: undefined,
      type: 'News',
      active: true,
      backgroundFile: news.backgroundFile,
      files: news.files ?? [],
      idsProfiles: [...(news.idsProfiles ?? [])],
      idsClassRooms: [...(news.idsClassRooms ?? [])],
      releaseDate: news.releaseDate ? new Date(news.releaseDate) : undefined,
      idSchool: news.idSchool,
      hasAuthorization: news.hasAuthorization,
      authorizationLimit: news.authorizationLimit
        ? new Date(news.authorizationLimit)
        : undefined,

    };
    return duplicatedNews;
  }

  private handleSuccessDuplicate(): void {
    this.discardedOccasion.emit(true);
    this.snackbarService.open(
      'Notícia duplicada com sucesso!',
      SnackbarTypeEnum.SUCCESS,
      'center',
      'bottom'
    );
  }

  private async openDuplicateDialog(initialTitle: string): Promise<string | null> {
    const dialogInfo: FormDialogDto = {
      primaryText: 'Duplicar notícia',
      showInput: true,
      inputLabel: 'Título da notícia',
      inputInitialValue: initialTitle,
      btnCancelText: 'Cancelar',
      btnConfirmText: 'Duplicar',
    };

    const dialogRef = this.dialog.open(FormDialogComponent, {
      data: dialogInfo,
      panelClass: ['custom-dialog-confirmation'],
      disableClose: true,
    });

    return dialogRef.afterClosed().toPromise();
  }

  async duplicateOccasion(occasion: Occasion) {
    const newTitle = await this.openDuplicateDialog(`(Cópia) ${occasion.title}`);

    if (newTitle && occasion.id) {
      try {
        const news = await this.duplicateNews(occasion.id, newTitle);
        this.newsService
          .save(news)
          .toPromise()
          .then(() => this.handleSuccessDuplicate());
      } catch (error) {
        console.log(error);
        this.snackbarService.open(
          this.msgDiscardSnackError,
          SnackbarTypeEnum.ERROR,
          'center',
          'bottom'
        );
      }
    }
  }

  onSelect(emit: string, occasion: Occasion) {
    switch (emit) {
      case 'actionEdit':
        if (this.typeOccasion === 'NEWS') {
          this.router.navigate(['news', occasion.id]);
        } else {
          this.router.navigate(['event', occasion.id]);
        }
        break;
      case 'actionDelete':
        this.deleteOccasion(occasion);
        break;
      case 'actionDetails':
        if (this.typeOccasion === 'NEWS') {
          this.router.navigate(['news', occasion.id, 'details']);
        } else {
          this.router.navigate(['event', occasion.id]);
        }
        break;
      case 'actionDuplicate':
        this.duplicateOccasion(occasion);
        break;
    }
  }
}
